export const storeFeatureTranslationEN = {
  StoreSettingPage: {
    head_title: 'List of store settings',
    search: 'Search',
    store_code: 'Store code',
    store_name: 'Store name',
    sale_type: 'Sale type',
    specific_setting: 'Specific setting',
    unspecified: 'Unspecified',
    only: 'Only',
    none_only: 'None only',
    consistency_check: 'Consistency check',
    all: 'All',
    ok: 'OK',
    ng: 'NG',
    individual_setting: 'Individual setting',
    food_registration_leak_check: 'Food management registration leak check',
    save: 'save',
    specific_setting_html: 'Store specific settings<br />presence or absence',
    ingredient_management_registration_omission_check: 'Ingredient management registration omission<br />check',
  },
};
